import React from 'react';
import { AppSwitcher } from '../app-switcher/app-switcher';
import styles from './portal-header.module.scss';
import { AppNavItem } from '../app-switcher/utils/interfaces';
import { useApplications } from '../../hooks/useApplications';
import { MimicBadge } from '@spins-gcp/shared-components-react';
import { useAtom } from 'jotai';
import { pageTitleAtom } from '../../atoms/pageTitleAtom';
import DaapLogo from '../../../assets/daap-logo.png';
import { useMimic } from '../../hooks/useMimic';
import { UserMenu } from './user-menu';

export function PortalHeader() {
  const { apps, loading } = useApplications();
  const { isMimic } = useMimic();
  const [pageTitle] = useAtom(pageTitleAtom);

  // daapApplications is already subscription-scoped and ordered server-side
  const navItems: AppNavItem[] = apps.map((app) => ({
    path: `/${app.slug}`,
    pageName: app.name,
    abbreviation: app.abbreviation,
  }));

  return (
    <div className={styles['header']}>
      <div className={styles['header-left']}>
        <img src={DaapLogo} alt="DAAP" className={styles['logo']} />
        <div className={styles['divider']} />
        <span className={styles['page-name']}>{pageTitle}</span>
        {isMimic && <MimicBadge />}
      </div>
      <div className={styles['header-right']}>
        <AppSwitcher applications={loading ? [] : navItems} />
        <div className={styles['divider']} />
        <UserMenu />
      </div>
    </div>
  );
}
